module.exports = __webpack_public_path__ + "static/media/ProximaNova-LightIt.0efcf5f6.woff";